import { z } from "zod";

import { ServiceEntity } from "~/entities/service";
import { ServiceCategoryEntity } from "~/entities/service-category";

const zSchema = z.record(
  ServiceCategoryEntity.zSchema.shape.id,
  z.array(
    ServiceEntity.zSchema
      .pick({
        id: true,
      })
      .extend({
        count: z.coerce.number().int().nonnegative(),
      }),
  ),
);
type Schema = z.infer<typeof zSchema>;

export { zSchema };
export type { Schema };
